import { useSelector } from 'react-redux';

import { tenantsSelector, tenantsSelectorData, tenantsStatusSelector } from './selector';

export const useTenants = () => useSelector(tenantsSelector);

export const useTenantsData = () => useSelector(tenantsSelectorData);

export const useTenantsStatus = () => useSelector(tenantsStatusSelector);
